import { DataType } from "../../dataTypes/DataType";
import { IQueryInfo } from "./IQueryInfo";
import { QueryType } from "../QueryType";

export class SimpleXPathQueryInfo implements IQueryInfo {

    private sampleQuery: string;

    public constructor() {
        this.sampleQuery = "/";
    }

    public name: QueryType = QueryType.SimpleXPath;

    public displayName: string = "XPath (Browser native)";

    public readonly inputDataType: DataType = DataType.Xml;

    public readonly outputDataType: DataType = DataType.Xml;

    public readonly hasQuery: boolean = true;

    public getSampleQuery(): string {
        return this.sampleQuery;
    }

    public getSelectAllQuery(): string {
        return "/";
    }

    public setSampleQuery(query: string): void {
        this.sampleQuery = query;
    }

    public helpUrl: string = "https://www.w3schools.com/XML/xml_xpath.asp";

    public editorMode: string = "text";
}